const pick = require('../utils/pick');
const { WEB_VITALS } = require('../../constants/initiatives');
const { getConfiguration } = require('../config');
const {
  FCP, LCP, CLS, INP,
} = require('../../constants/metrics');
const { METRICS } = require('../../constants/configurations');


const requiredMetrics = [FCP, LCP, CLS];

// Check if browser supports interactionId (and so supports INP)
// https://github.com/GoogleChrome/web-vitals/blob/main/src/onINP.ts#L110
if (typeof window !== 'undefined' && 'PerformanceEventTiming' in window
  && 'interactionId' in window.PerformanceEventTiming.prototype) {
  requiredMetrics.push(INP);
}

const preparePayload = (_, data) => {
  const metrics = getConfiguration(METRICS, WEB_VITALS);
  const webVitalsMetrics = pick(data, metrics);

  if (!Object.keys(webVitalsMetrics).length) {
    throw new Error('Metrics not found');
  }

  const webVitalsMetricsKeys = Object.keys(webVitalsMetrics);
  if (!requiredMetrics.every(metric => webVitalsMetricsKeys.indexOf(metric) !== -1)) {
    throw new Error('Metrics missing');
  }

  return {
    name: WEB_VITALS,
    data: webVitalsMetrics,
  };
};

module.exports = preparePayload;
